import { connect } from 'react-redux';
import { compose } from 'redux'
import { firebaseConnect } from 'react-redux-firebase'
import DeleteWishConfirmation from './DeleteWishConfirmation';
import { getWishIdToDelete } from 'store/deleteWish/selectors';
import { clearWishToDelete } from 'store/deleteWish/actions';

const actions = dispatch => ({
  onClose: () => {
    dispatch(clearWishToDelete());
  }
});

export default compose(
  firebaseConnect((props, store) => {
    const state = store.getState();
    const wishId = getWishIdToDelete(state);

    return [
      `wishes/${wishId}`
    ];
  }),
  connect(state => {
    const wishId = getWishIdToDelete(state);
    const data = state.firebase.data;

    return {
      wishId,
      wish: data.wishes && data.wishes[wishId],
      open: !!wishId
    };
  }, actions)
)(DeleteWishConfirmation);



// WEBPACK FOOTER //
// ./src/components/dialogs/DeleteWishConfirmation/index.js